import GDPRBanner from '@acri-tools/react-tools/components/GDRPBanner/GDPRBanner';
import React,{Component} from 'react';

import { connect } from 'react-redux';


interface Props{
    // REDUX
    gdpr:any
}

export const GDPR_LINK = "https://www.damps.info/api/user-manager/v1/files/media/ACRI-ST_GDPR_DAMPS.pdf";

class GDPR extends Component<Props>{
    render(){
        return (<GDPRBanner
            consent_options={{
                ga: "I give consent to have my activity tracked on Google Analytics to help participate in the development of this website"
            }}
            link={`${GDPR_LINK}?view=true`}
        />)
    }

};


export default connect((state:any)=>{
    return {
        gdpr: state.gdpr,
    }
})(GDPR);
